import script from "./AdminCreateCustomer.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminCreateCustomer.vue?vue&type=script&setup=true&lang=js"

import "@/assets/styles/sfc/components/sites/AdminCreateCustomer.css?vue&type=style&index=0&id=82a20888&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-82a20888"]])

export default __exports__